import React, { useEffect, useRef, useState } from "react";
import { FaCalendar } from "react-icons/fa6";
import { DateRange } from "react-date-range";
import { toast } from "react-toastify";

function RangeOfDate({ setStartDate, setEndDate }) {
  const today = new Date();
  const maxRange = 90 * 24 * 60 * 60 * 1000;
  const [showCalendar, setShowCalendar] = useState(false);
  const [tempRange, setTempRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  const calendarRef = useRef(null);

  const handleSelect = (ranges) => {
    const { startDate, endDate } = ranges.selection;
    if (endDate - startDate > maxRange) {
      toast.error("You can select maximum of 3 months range");
      return;
    }
    setTempRange([ranges.selection]);
  };

  const applyDateRange = () => {
    const startDate = tempRange[0].startDate;
    const endDate = new Date(tempRange[0].endDate);

    if (endDate > today) {
      toast.error("End date should be less than or equal to today");
      return;
    }


    endDate.setHours(23, 59, 59, 999);

    setStartDate(startDate.toISOString());
    setEndDate(endDate.toISOString());
    setShowCalendar(false);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setShowCalendar(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <>
    <div className="date-select">
    <p>
          Selected Date:{" "}
          {tempRange[0].startDate && tempRange[0].endDate && (
            <span className="selectedDate-download">
              {new Date(tempRange[0].startDate).toLocaleDateString("en-GB")} -{" "}
              {new Date(tempRange[0].endDate).toLocaleDateString("en-GB")}
            </span>
          )}
        </p>
      </div>
    <div className="datetime-inputs">
      <div className="date-select">
        <p>Select Date Range :-</p>
      </div>
      <div className="calendar-wrapper">
        
        <button
          className="search-btn-date-report"
          onClick={() => setShowCalendar(!showCalendar)}
        >
          <FaCalendar />
        </button>
        {showCalendar && (
          <div ref={calendarRef} className="calendar-popup">
            <DateRange
              ranges={tempRange}
              onChange={handleSelect}
              maxDate={today}
              moveRangeOnFirstSelection={false}
              className="calendar-range-report"
            />
            <button className="apply-button-report" onClick={applyDateRange}>
              Apply
            </button>
          </div>
        )}
      </div>
    </div>
      </>
  );
}

export default RangeOfDate;